export default __webpack_public_path__ + "static/media/sa4.26a245cd.jpg";